<template>
  <div class="flex-1 flex flex-col justify-center items-center">
    <div
      class="animate-pulse px-2 py-1 xl:px-4 xl:py-2 rounded-md text-xl xl:text-3xl font-bold tracking-wider flex items-baseline gap-1  bg-red-500 text-yellow-200 text-shadow shadow-black"
    >
      <TriangleAlert class="size-6 xl:size-8 shrink-0" />
      <span>Falha na ligação de rede!</span>
    </div>
    <WifiBootRestoreNotice />
  </div>
</template>

<script lang="ts" setup>
import { TriangleAlert } from 'lucide-vue-next'
import WifiBootRestoreNotice from '@/components/WifiBootRestoreNotice.vue'
</script>
